import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { MetricsContext } from "contexts/Metrics";
import { OrganizationUserContext } from "contexts/Organization";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext, useEffect, useState } from "react";

import styles from "./styles";

const MINIMUM_DISPLAYED = 3;

const MetricsByTemplate = () => {
  const { templates } = useContext(OutreachTemplatesContext);
  const { currentOrg, emailSettings } = useContext(OrganizationUserContext);
  const { templateStats, fetchMetricsByTemplate, bestPerformingTemplate } =
    useContext(MetricsContext);

  const [more, setMore] = useState(false);

  const getTemplateName = (templateId: number) => {
    const templateName = templates.find(
      (template) => template.id === templateId,
    )?.name;
    return templateName;
  };

  const isLastUsedTemplate = (templateId: number) => {
    const template = emailSettings?.emailSettingTemplates?.find(
      (template) => template.templateId === templateId,
    );
    return Boolean(template);
  };

  const showAsPercentage = (value: number) => {
    return `${((value || 0) * 100).toFixed(1)}%`;
  };
  useEffect(() => {
    if (currentOrg?.id) {
      fetchMetricsByTemplate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  const displayedStats = more
    ? templateStats
    : templateStats.slice(0, MINIMUM_DISPLAYED);

  return templateStats?.length > 0 ? (
    <Table size="small" sx={styles.metricsWrapper}>
      <TableHead>
        <TableRow>
          <TableCell sx={styles.header}>Templates</TableCell>
          <TableCell align="right" sx={styles.annotation}>
            Emails
          </TableCell>
          <TableCell align="right" sx={styles.annotation}>
            Opened
          </TableCell>
          <TableCell align="right" sx={styles.annotation}>
            Responded
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {displayedStats.map((row) => (
          <TableRow
            key={row.templateId}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <TableCell component="th" scope="row" sx={{ pl: 2, pr: 0 }}>
              {getTemplateName(row.templateId)}
              {row.templateId === bestPerformingTemplate ? (
                <Box sx={styles.topPerforming}>Top Performing 🏆</Box>
              ) : (
                <>
                  {isLastUsedTemplate(row.templateId) && (
                    <Box
                      sx={{ color: "info.main", fontSize: 8, fontWeight: 600 }}
                    >
                      Last Used
                    </Box>
                  )}
                </>
              )}
            </TableCell>
            <TableCell align="right">{row.outreachCount}</TableCell>
            <TableCell align="right">
              {showAsPercentage(row.openedPercentage)}
            </TableCell>
            <TableCell align="right">
              {showAsPercentage(row.respondedPercentage)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>

      {!more && templateStats.length > MINIMUM_DISPLAYED && (
        <Button
          size="small"
          sx={{ fontSize: 10, ml: 1 }}
          onClick={() => setMore(true)}
        >
          See More
        </Button>
      )}
    </Table>
  ) : (
    <></>
  );
};

export default MetricsByTemplate;
